// extracted by css-extract-rspack-plugin
export default {"Box":"archive-list-module__Box__UGRPLRs"};